import * as React from 'react';

class ArrowRightSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon arrow-right-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M14.75 6.84268C14.7161 6.56844 14.6071 6.30889 14.435 6.09268C12.6977 3.95585 10.6939 2.05035 8.4725 0.422678C8.39305 0.360196 8.30179 0.314417 8.2042 0.288092C8.10662 0.261766 8.00472 0.255438 7.90462 0.269487C7.80453 0.283536 7.70831 0.317671 7.62174 0.369844C7.53517 0.422016 7.46003 0.491149 7.40086 0.573089C7.34168 0.655029 7.29967 0.748085 7.27736 0.846668C7.25505 0.94525 7.2529 1.04733 7.27103 1.14676C7.28917 1.2462 7.32721 1.34094 7.38289 1.4253C7.43856 1.50966 7.51071 1.5819 7.595 1.63768C9.42293 2.98331 11.0935 4.53056 12.575 6.25018H1.25C1.05109 6.25018 0.860322 6.3292 0.71967 6.46985C0.579018 6.6105 0.5 6.80127 0.5 7.00018C0.5 7.19909 0.579018 7.38986 0.71967 7.53051C0.860322 7.67116 1.05109 7.75018 1.25 7.75018H12.5975C11.0961 9.48101 9.40557 11.0382 7.5575 12.3927C7.40532 12.5124 7.30532 12.6862 7.27841 12.878C7.25151 13.0697 7.29977 13.2644 7.41312 13.4213C7.52647 13.5783 7.69612 13.6853 7.88658 13.72C8.07704 13.7548 8.27355 13.7145 8.435 13.6077C10.6536 11.9881 12.6572 10.0929 14.3975 7.96768C14.5964 7.73508 14.7194 7.4472 14.75 7.14268C14.7548 7.0953 14.7548 7.04756 14.75 7.00018C14.7555 6.94782 14.7555 6.89503 14.75 6.84268Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default ArrowRightSvg;
